module.exports = __webpack_public_path__ + "img/circle-plus.b6c55e96.svg";